import { ServerSidePropsContext } from 'providers/ServerSideProps'
import React, { createContext, useContext } from 'react'

export type AssetsContextProps = {
  assets: {
    article: any;
    banners: any;
    favicons: any;
    footer: any;
    logos: any;
    icons: any;
    menus: any;
    slotLayouts: any;
    teasers: any;
    templates: any;
    topbar: any;
  }
}

export const AssetsContext = createContext<AssetsContextProps>({} as AssetsContextProps)

const AssetsProvider = ({ children }) => {
  const serverSideContext = useContext(ServerSidePropsContext)
  return (
    <AssetsContext.Provider
      value={{
        assets: serverSideContext.siteConfig.assets
      }}
    >
      {children}
    </AssetsContext.Provider>
  )
}

export default AssetsProvider
